<script>
  import OsIcon from './icons/OsIcon.svelte';
  import SessionEntry from './SessionEntry.svelte';
  import KeyHandler from './components/KeyHandler.svelte';
  import api from './api.js';

  export let appName = '';

  let sessions = [];
  let selected = -1;

  const load = async () => {
    sessions = await api.GET(`/sessions?app=${appName}`);
  }

  const getHref = id => `?app=${appName}&sid=${id}`;

  const setSelected = n => {
    if (n < 0) n = 0;
    if (n > sessions.length-1) n = sessions.length -1;
    selected = n;
  }

  const nav = () => {
    if (selected === -1) return;
    const sid = sessions?.[selected].id;
    window.location.href = getHref(sid);
  }

  const keyHandlers = {
    'ArrowDown': () => setSelected(selected+1),
    'ArrowUp': () => setSelected(selected-1),
    'PageDown': () => setSelected(selected+10),
    'PageUp': () => setSelected(selected-10),
    'Enter': nav,
    'Space': nav,
	};

  load();
</script>

<svelte:head>
  <title>{appName}</title>
</svelte:head>

<KeyHandler handlers={keyHandlers} />
<div>
  {#each sessions as x, i}
    <SessionEntry
      href={getHref(x.id)}
      isSelected={i===selected} 
      showAppName={appName==='_all'}
      {...x}
    />
  {/each}
</div>

<style>
</style>
